import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: string | SafeHtml | null | undefined): SafeHtml {
    if (value == null) {
      // Fallback sicuro: stringa vuota sanificata
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    // Se è già SafeHtml, lo ritorno direttamente
    if (typeof value !== 'string') {
      return value as SafeHtml;
    }

    // Se è stringa, la sanifico
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}